{
  "el": {
    "contact": {
      "actions": {
        "accept": "OK",
        "add": "Προσθήκη επαφής",
        "add_type": "Προσθήκη: {type}",
        "backInspirationLists": "Πίσω στις λίστες εμπνεύσεων",
        "cancelNew": "Αναίρεση",
        "deleteCustomer": "Διαγραφή πελάτη...",
        "deleteEmployee": "Διαγραφή μέλους ομάδας...",
        "deleteLead": "Διαγραφή Lead...",
        "deletePartner": "Διαγραφή συνεργάτη...",
        "edit": "Επεξεργασία",
        "impersonate": "Υπόδυση",
        "impersonateStart": "Πέρνα μέσα από την πορτοκαλί πύλη και δες την πλατφόρμα όπως τη βλέπει {name}.",
        "impersonateStop": "Επιστροφή στον κόσμο σου",
        "invite": "Αποστολή πρόσκλησης",
        "newTicket": "Νέα συνομιλία",
        "resendInvitationEmail": "Επαναποστολή email πρόσκλησης",
        "searchContact": "Αναζήτηση επαφής",
        "searchCustomer": "Αναζήτηση πελάτη",
        "searchEmployee": "Αναζήτηση μέλους ομάδας",
        "selectAll": "Επιλογή όλων των {total} επαφών",
        "selectOption": "Επιλογή",
        "setProfilePicture": "Ορισμός φωτογραφίας προφίλ",
        "showall": "Εμφάνιση όλων",
        "unSelectAll": "Εκκαθάριση επιλογής."
      },
      "attributes": {
        "language": "Γλώσσα",
        "timezone": "Ζώνη ώρας",
        "title": "Τίτλος"
      },
      "labels": {
        "address": "Διεύθυνση",
        "all": "Όλες οι επαφές",
        "back_to_overview": "Πίσω στην επισκόπηση",
        "cannot_create_role": "Απευθύνσου σε έναν ιδιοκτήτη για να δημιουργήσει νέα επαφή",
        "company": "Οργανισμός",
        "company_all": "Όλοι οι οργανισμοί",
        "contact_status": {
          "active": "Ενεργό",
          "added": "Δεν έχει προσκληθεί ακόμη",
          "all": "Όλες οι καταστάσεις",
          "blocked": "Απενεργοποιημένο",
          "invited": "Προσκεκλημένο",
          "status": "Κατάσταση"
        },
        "contact_type": "Τύπος",
        "customer": "Πελάτης",
        "customers": "Πελάτες",
        "employee": "Ομάδα",
        "export_contacts": "Εξαγωγή επαφών",
        "general": "Γενικά",
        "impersonateInactiveProfile": "Αυτό το φανταστικό άτομο δεν είναι ακόμα ενεργό. Ενεργοποίησε πρώτα τον πελάτη.",
        "invite": "Ναι, πρόσκληση επαφών",
        "inviteProfileFirstCustomer": "Προσκάλεσε πρώτα τον πελάτη στην πλατφόρμα για να μπορέσεις να στείλεις μήνυμα, να κάνεις υπόδυση ή να ξαναστείλεις το email πρόσκλησης",
        "inviteProfileFirstPartner": "Προσκάλεσε πρώτα τον συνεργάτη στην πλατφόρμα για να μπορέσεις να κάνεις υπόδυση ή να ξαναστείλεις το email πρόσκλησης",
        "last_login": "Τελευταία σύνδεση",
        "last_seen": "τελευταία εμφάνιση",
        "last_seen_not_seen_yet": "καμία σύνδεση ακόμη",
        "lead": "Lead",
        "name": "Όνομα",
        "name_or_email_address": "Όνομα ή διεύθυνση email",
        "name_or_email_address_phone": "Όνομα, διεύθυνση email ή τηλέφωνο",
        "noContacts": "Χωρίς επαφές",
        "no_contacts": "Δεν υπάρχουν επαφές για εξαγωγή",
        "no_contacts_results": "Αυτή η αναζήτηση δεν έχει αποτελέσματα. Δοκίμασε άλλα φίλτρα για να βρεις το κατάλληλο άτομο.",
        "no_contacts_results_subtitle": "Αυτή η αναζήτηση δεν έχει αποτελέσματα. Δοκίμασε άλλα φίλτρα για να βρεις το κατάλληλο άτομο.",
        "no_contacts_results_title": "Δεν βρέθηκαν επαφές",
        "number_contacts": "Καμία επαφή | 1 επαφή | {count} επαφές",
        "other": "Άλλο",
        "partner": "Συνεργάτης",
        "partners": "Συνεργάτες",
        "project": "Έργο",
        "secondary_contact": "Δευτερεύουσα επαφή",
        "selectOne": "Επίλεξε τουλάχιστον 1 επαφή",
        "selectProjectForImpersonation": "Για ποιο έργο θέλεις να υποδυθείς {customer_name};",
        "selected": "Επιλέχθηκε {selected} επαφή. | Επιλέχθηκαν {selected} επαφές.",
        "sorting": {
          "last_name": "Όνομα",
          "session_started_at": "Τελευταία σύνδεση",
          "status": "Κατάσταση"
        },
        "totalSelected": "Έχουν επιλεγεί και οι {total} επαφές.",
        "units": "Ακίνητα"
      },
      "navigation": {
        "backToContacts": "Πίσω στις επαφές"
      },
      "placeholders": {
        "byNameOrEmailAddress": "Με όνομα ή διεύθυνση email"
      },
      "validation": {
        "emailTaken": "Η διεύθυνση email είναι ίδια με την προηγούμενη",
        "mustBeEmailAddress": "Απαιτείται έγκυρη διεύθυνση email",
        "requireEmailAddress": "Το email είναι υποχρεωτικό"
      }
    }
  }
}
